import { MaterialWorking, LabourWorking } from '../../data/interfaces'

export const materialWorkingTotal = (w: MaterialWorking): number => {
  if (w.netCost && w.markUpPercent) {
    return w.netCost + (w.netCost * (w.markUpPercent / 100))
  }
  return w.totalCost || w.total || 0
}

export const labourWorkingTotal = (w: LabourWorking): number => (w.hours || 0) * (w.rate || 0)

/**
 * Whether a working belongs to the given section. Treats `null` and `undefined`
 * as the same "no section" bucket so that pre-existing workings (which come back
 * from the API with `sectionId: null`) land in the General section, whose id is `undefined`.
 */
export const inSection = (
  workingSectionId: number | null | undefined,
  sectionId: number | null | undefined
): boolean => (workingSectionId ?? null) === (sectionId ?? null)
